import React from 'react';
import { IIconProps } from './utils';

export const ExpandRounded = ({
  fill = 'currentColor', height = null, width = null, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 30 30" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M3.75 26.25V20M3.75 26.25H10M3.75 26.25L11.25 18.75M18.75 11.25L26.25 3.75M26.25 3.75V10M26.25 3.75H20"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
